import React, {Component} from 'react';
import { ServiceCollectionParam } from "./ServiceCollection";
import { Link } from "react-router-dom";
import CourseResultsFilter from "../common/filter/CourseResultsFilter";
import UserResult from "../common/UserResult";

interface State {
    rows: UserResult[],
    unconfirmed: boolean,
    finalExamDone: boolean,
    minimumCompleted: boolean,
    sortColumn: string | null,
    sortDirection: 'asc' | 'desc'
}

export default class CourseResultListPage extends Component<ServiceCollectionParam, {}> {

    state: State = {
        rows: [],
        unconfirmed: false,
        finalExamDone: false,
        minimumCompleted: false,
        sortColumn: null,
        sortDirection: 'asc'
    };

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {
        const filter = new CourseResultsFilter().readFromRaw(this.state);

        this.state.rows = await this.props.services.dao.getCourseResults(filter);

        // Apply current sorting if any
        this.sortData();

        this.setState({});
    }

    async putUpdateScriptToClipboard() {
        const filter = new CourseResultsFilter().readFromRaw(this.state);

        const data = await this.props.services.dao.getCourseResultsUpdateScript(filter);

        await navigator.clipboard.writeText(data.code);
    }

    async toggleUnconfirmed() {
        this.state.unconfirmed = !this.state.unconfirmed;

        await this.loadData();
    }

    async toggleFinalExamDone() {
        this.state.finalExamDone = !this.state.finalExamDone;

        await this.loadData();
    }

    async toggleMinimumCompleted() {
        this.state.minimumCompleted = !this.state.minimumCompleted;

        await this.loadData();
    }

    sortByColumn(column: string) {
        if (this.state.sortColumn === column) {
            // Toggle direction if same column
            this.state.sortDirection = this.state.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            // New column, default to ascending
            this.state.sortColumn = column;
            this.state.sortDirection = 'asc';
        }

        this.sortData();
        this.setState({});
    }

    sortData() {
        if (!this.state.sortColumn) return;

        const column = this.state.sortColumn;
        const direction = this.state.sortDirection;

        this.state.rows.sort((a: UserResult, b: UserResult) => {
            let valueA: any;
            let valueB: any;

            switch (column) {
                case 'name':
                    valueA = a.declarationName || '';
                    valueB = b.declarationName || '';
                    break;
                case 'username':
                    valueA = a.username || '';
                    valueB = b.username || '';
                    break;
                case 'project':
                    valueA = a.mainPointsInScale || 0;
                    valueB = b.mainPointsInScale || 0;
                    break;
                case 'bonus':
                    valueA = a.bonusPointsInScale || 0;
                    valueB = b.bonusPointsInScale || 0;
                    break;
                case 'test1':
                    valueA = a.getExamResultCalculator().getTest1Points() || 0;
                    valueB = b.getExamResultCalculator().getTest1Points() || 0;
                    break;
                case 'test2':
                    valueA = a.getExamResultCalculator().getTest2Points() || 0;
                    valueB = b.getExamResultCalculator().getTest2Points() || 0;
                    break;
                case 'finalExam':
                    valueA = a.getExamResultCalculator().getFinalExamPoints() || 0;
                    valueB = b.getExamResultCalculator().getFinalExamPoints() || 0;
                    break;
                case 'examTotal':
                    valueA = a.getExamResultCalculator().getTotalPoints() || 0;
                    valueB = b.getExamResultCalculator().getTotalPoints() || 0;
                    break;
                case 'total':
                    valueA = a.getFinalResults().getTotalPoints() || 0;
                    valueB = b.getFinalResults().getTotalPoints() || 0;
                    break;
                case 'grade':
                    valueA = a.getFinalResults().gradeFinalGrade() || '';
                    valueB = b.getFinalResults().gradeFinalGrade() || '';
                    break;
                default:
                    return 0;
            }

            // Handle string comparison
            if (typeof valueA === 'string' && typeof valueB === 'string') {
                const comparison = valueA.toLowerCase().localeCompare(valueB.toLowerCase());
                return direction === 'asc' ? comparison : -comparison;
            }

            // Handle numeric comparison
            if (valueA < valueB) {
                return direction === 'asc' ? -1 : 1;
            }
            if (valueA > valueB) {
                return direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
    }

    getSortIcon(column: string): string {
        if (this.state.sortColumn !== column) {
            return '';
        }
        return this.state.sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
    }

    render() {
        let rowNr = 1;

        return (
            <>
            <label>
                <input type="checkbox"
                   onChange={ () => this.toggleUnconfirmed() } />
                &nbsp;Ainult kinnitamata&nbsp;
            </label>

            <label>
                <input type="checkbox"
                   onChange={ () => this.toggleFinalExamDone() } />
                &nbsp;Lõppeksam tehtud&nbsp;
            </label>

            <label>
                <input type="checkbox"
                   onChange={ () => this.toggleMinimumCompleted() } />
                &nbsp;Minimaalne tehtud&nbsp;
            </label>

            <table className="table">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('name'); }}>
                            Name
                            {this.getSortIcon('name') && <i className="material-icons">{this.getSortIcon('name')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('username'); }}>
                            Kasutajanimi
                            {this.getSortIcon('username') && <i className="material-icons">{this.getSortIcon('username')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('project'); }}>
                            Projekt
                            {this.getSortIcon('project') && <i className="material-icons">{this.getSortIcon('project')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('bonus'); }}>
                            Boonus
                            {this.getSortIcon('bonus') && <i className="material-icons">{this.getSortIcon('bonus')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('test1'); }}>
                            1. kt
                            {this.getSortIcon('test1') && <i className="material-icons">{this.getSortIcon('test1')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('test2'); }}>
                            2. kt
                            {this.getSortIcon('test2') && <i className="material-icons">{this.getSortIcon('test2')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('finalExam'); }}>
                            Eksam
                            {this.getSortIcon('finalExam') && <i className="material-icons">{this.getSortIcon('finalExam')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('examTotal'); }}>
                            Eksam kokku
                            {this.getSortIcon('examTotal') && <i className="material-icons">{this.getSortIcon('examTotal')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('total'); }}>
                            Kokku
                            {this.getSortIcon('total') && <i className="material-icons">{this.getSortIcon('total')}</i>}
                        </a>
                    </th>
                    <th scope="col">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.sortByColumn('grade'); }}>
                            Hinne&nbsp;{this.getSortIcon('grade') && <i className="material-icons">{this.getSortIcon('grade')}</i>}
                        </a>
                    </th>
                </tr>
                </thead>
                <tbody>
                { this.state.rows.map((row: any) => (
                    <tr key={ rowNr }>
                        <td>{ rowNr++ }</td>
                        <td><Link to={`/results/${row.username}`}>{ row.declarationName }</Link></td>
                        <td>{ row.username }</td>
                        <td>{ row.mainPointsInScale }</td>
                        <td>{ row.bonusPointsInScale }</td>
                        <td>{ row.getExamResultCalculator().getTest1Points() }</td>
                        <td>{ row.getExamResultCalculator().getTest2Points() }</td>
                        <td>{ row.getExamResultCalculator().getFinalExamPoints() }</td>
                        <td>{ row.getExamResultCalculator().getTotalPoints() }</td>
                        <td>{ row.getFinalResults().getTotalPoints() }</td>
                        <td>{ row.getFinalResults().gradeFinalGrade() }</td>
                    </tr>))
                }
                <tr>
                    <td colSpan={8}>
                        <button
                            onClick={() => this.putUpdateScriptToClipboard()}
                            className="btn btn-success">Script to Clipboard</button>
                    </td>
                </tr>

                </tbody>
            </table>
            </>);
    }

}
